import { TableHead } from "@/components/ui/table";
import type { SortKey } from "./types";

export const Kpi = ({
  label, value, emphasis, tone,
}: {
  label: string;
  value: string;
  emphasis?: boolean;
  tone?: "destructive";
}) => (
  <div className="rounded-md border bg-card p-3">
    <div className="text-xs text-muted-foreground">{label}</div>
    <div
      className={`mt-1 ${emphasis ? "text-xl font-semibold" : "text-lg font-medium"} ${
        tone === "destructive" ? "text-destructive" : ""
      }`}
    >
      {value}
    </div>
  </div>
);

export const SortableHead = ({
  label, k, sortKey, sortDir, onClick, className,
}: {
  label: string;
  k: SortKey;
  sortKey: SortKey;
  sortDir: "asc" | "desc";
  onClick: (k: SortKey) => void;
  className?: string;
}) => {
  const active = sortKey === k;
  return (
    <TableHead className={className}>
      <button
        type="button"
        onClick={() => onClick(k)}
        className={`inline-flex items-center gap-1 hover:text-foreground ${
          active ? "text-foreground" : "text-muted-foreground"
        }`}
      >
        {label}
        {active && <span className="text-[10px]">{sortDir === "asc" ? "▲" : "▼"}</span>}
      </button>
    </TableHead>
  );
};
